import { useTranslation } from 'next-i18next/pages';

import { HeaderVariantType } from '../../layouts/pc/Header';

type Props = {
  width?: number;
  height?: number;
  isOpen: boolean;
  variant?: HeaderVariantType;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

/** 막대 4개의 위치/회전 조합은 globals.css 의 .menu-btn* 에 있다 */
export default function MenuButton({
  width = 20,
  height = 20,
  isOpen,
  variant = 'default',
  setIsOpen,
}: Props) {
  const { t } = useTranslation('common');

  return (
    <div
      className="relative z-[99999]"
      style={{ width: `${width}px`, height: `${height}px` }}
    >
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className={`menu-btn menu-btn--${variant} ${isOpen ? 'menu-btn--open' : ''}`}
        aria-label={t(isOpen ? '메뉴 닫기' : '메뉴 열기')}
        aria-expanded={isOpen}
      >
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  );
}
